import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { legalProblemCodeBreadcrumbsHistory } from './functions';

const LegalProblemCodeBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="legal-problem-code-breadcrumbs"
      history={legalProblemCodeBreadcrumbsHistory(t, location)}
    />
  );
};

export default LegalProblemCodeBreadcrumbs;
